(function(root, factory) {
  const engine = factory();
  if (typeof module === 'object' && module.exports) module.exports = engine;
  else root.MarkedFit = engine;
})(typeof window === 'object' ? window : globalThis, function() {
  function normalise(value) {
    const key = String(value).trim().toLowerCase().replace(/[\s_-]/g, '');
    const aliases = { '3xsmall':'XXXS','3xs':'XXXS','xxxsmall':'XXXS','xxxs':'XXXS','2xsmall':'XXS','2xs':'XXS','xxsmall':'XXS','xxs':'XXS','extrasmall':'XS','xsmall':'XS','xs':'XS','small':'S','s':'S','medium':'M','m':'M','large':'L','l':'L','extralarge':'XL','xlarge':'XL','xl':'XL','2xlarge':'XXL','xxlarge':'XXL','xxl':'XXL','smallmedium':'S/M','sm':'S/M','s/m':'S/M' };
    return aliases[key] || String(value).replace(/\s/g, '').toUpperCase();
  }
  function inside(value, range) {
    return Number.isFinite(value) && value >= range[0] && value <= range[1];
  }
  function rank(value, range) {
    return Math.min(value - range[0], range[1] - value) / (range[1] - range[0]);
  }
  function matches(product, database, measures) {
    const family = database.families[product.family];
    if (!family || family.manual || product.sizeIndex < 0) return [];
    return product.variants.flatMap(variant => {
      if (!variant.available) return [];
      const size = normalise(variant.options[product.sizeIndex]);
      const row = family.sizes[size];
      if (!row) return [];
      const dimension = family.kind === 'collar' ? 'neck' : 'chest';
      if (!row[dimension] || !inside(measures[dimension], row[dimension])) return [];
      let score = rank(measures[dimension], row[dimension]);
      let status = 'verified';
      if (family.kind === 'harness' && row.neck) {
        if (measures.neck == null) status = 'neck_needed';
        else if (!inside(measures.neck, row.neck)) return [];
        else score = Math.min(score, rank(measures.neck, row.neck));
      }
      if (row.opening != null) {
        if (measures.neck != null && measures.neck > row.opening) return [];
        status = 'fixed_opening';
      }
      return [{variant, size, row, score, status}];
    }).sort((a,b) => Number(b.status === 'verified') - Number(a.status === 'verified') || b.score - a.score);
  }
  return { normalise, inside, matches };
});
